import store from '../store'

import { addGetParameters, loadData, setUrlParameters } from '@/helper/requests'

export function makeMediaHostUrl (host, url) {
  /**
   * Формирует полный URL для медиа-хоста
   * @param {string} host - хост медиа-сервера
   * @param {string} url - путь к медиа-файлу
   * @returns {string} полный URL к медиа-файлу
   */
  return host + url
}

export function getUrl (host, base, urlname, action) {
  /**
   * Получает полный URL для запроса
   * @param {string} host - хост API
   * @param {string} base - имя инстанса (модуля)
   * @param {string} urlname - имя эндпоинта
   * @param {string} action - HTTP-метод
   * @returns {string} полный URL или пустую строку
   */
  const url = store.getters['urls/getPattern'](
    base,
    urlname,
    action
  )
  if (url !== '') { return host + url } else { return '' }
}

export function getUrlAllowed (base, urlname, action) {
  /**
   * Проверяет доступность URL для текущего пользователя
   * @param {string} base - имя инстанса (модуля)
   * @param {string} urlname - имя эндпоинта
   * @param {string} action - HTTP-метод
   * @returns {boolean} true, если URL доступен, иначе false
   */
  return store.getters['urls/getAllowed'](
    base,
    urlname,
    action
  )
}

export function checkUrlAllowedWithParameters (host, base, urlname, action, pars) {
  /**
   * Проверяет доступность параметризованного URL
   * @param {string} host - хост API
   * @param {string} base - имя инстанса (модуля)
   * @param {string} urlname - имя эндпоинта
   * @param {string} action - HTTP-метод
   * @param {Object} pars - параметры для подстановки в URL
   */
  const checks = [{
    name: urlname,
    parameters: pars
  }]
  loadData(`${host}/instance/named/url/parametrize/list/allowed/?urls=${JSON.stringify(checks)}`, (data) => {})
}

export function getUrlWithParameters (host, base, urlname, action, parameters = {}, get_parameters = null) {
  /**
   * Получает URL с подставленными параметрами
   * @param {string} host - хост API
   * @param {string} base - имя инстанса (модуля)
   * @param {string} urlname - имя эндпоинта
   * @param {string} action - HTTP-метод
   * @param {Object} parameters - параметры для замены в URL (ключ - шаблон, значение - замена)
   * @param {Object} get_parameters - GET-параметры для добавления к URL
   * @returns {string} полный URL со всеми параметрами
   */
  const url = setUrlParameters(
    getUrl(
      host,
      base,
      urlname,
      action
    ),
    parameters
  )
  if (get_parameters !== null) {
    return addGetParameters(url, get_parameters)
  }
  return url
}
